/* app/js/src/components/autopilot/graphicsRuleWizard/graphics-rule-wizard-nav.component.scss */
.cursor-pointer {
  cursor: pointer;
}
nav .btn-next {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
nav .btn-next:focus {
  outline-color: #ffffff;
}
nav .btn-next:hover {
  background-color: white;
  color: #232f3a;
}
nav .disabled.btn-next {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
nav {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
}
nav .hidden {
  visibility: hidden;
}
nav .btn-back {
  display: flex;
  align-items: center;
  cursor: pointer;
}
nav .rounded-btn,
nav .rounded-btn-prev {
  display: inline-block;
  background: #f1f3f4 no-repeat center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
}
nav .rounded-btn-prev {
  margin-right: 10px;
}
nav .btn-next {
  padding-left: 17px;
  padding-right: 17px;
}
/*# sourceMappingURL=graphics-rule-wizard-nav.component.css.map */
